import axios from "axios";

const loadCustomers = (callback) => {
    const config = {
        url: '/api/customers',
        method: 'GET',
    };

    axios.request(config).then(response => callback(response.data));
}

const getCustomer = (id, callback) => {
    const config = {
        url: `/api/customers/${id}`,
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const deleteCustomer = (id, callback) => {
    const config = {
        url: `/api/customers/${id}`,
        method: 'DELETE',
    }

    axios.request(config).then(response => callback(response.data));
}

const createCustomer = (customerData, callback) => {
    const config = {
        url: '/api/customers',
        method: 'POST',
        data: customerData,
    }

    axios.request(config)
        .then(response => callback(response.data));
}

const updateCustomer = (id, customerData, callback) => {
    const config = {
        url: `/api/customers/${id}`,
        method: 'PUT',
        data: customerData,
    }

    axios.request(config).then(response => callback(response.data));
}

const getMessage = (id, callback) => {
    const config = {
        url: `/api/sent-emails/message/${id}`,
        method: 'GET',
    }

    axios.request(config).then(response => callback(response.data));
}

const sendMessage = (id, data, callback) => {
    const config = {
        url: `/api/customers/message/${id}`,
        method: 'POST',
        data: data
    };

    axios.request(config)
        .then(response => callback(response.data))
}

const getPdf = (customerId, formId, callback) => {
    const config = {
        url: `/api/customers/${customerId}/forms/${formId}/pdf`,
        method: 'GET',
        responseType: "blob"
    }

    axios.request(config)
        .then(response => callback(response.data))
        .catch(error => {
            console.error("Error fetching file:", error);
            callback(null)
        });
}

const CustomerActions = {
    loadCustomers,
    getCustomer,
    createCustomer,
    updateCustomer,
    deleteCustomer,
    getMessage,
    sendMessage,
    getPdf,
}

export default CustomerActions;